/*
 * @Description: 字符串处理
 * @Author: erickuang
 * @Date: 2021-02-19 17:12:32
 * @LastEditor: erickuang
 * @LastEditTime: 2022-04-06 17:55:59
 */

import { isNullish } from './main';

/**
 * 获得具有占位符的字符串
 *
 * @param {string} str 原始字符串
 * @param {string} [placeholder='-'] 占位符
 * @return {*} 字符串或占位符
 */
export const getStringWithPlaceholder = function (str: string, placeholder = '-') {
  if ((typeof str === 'string' && str.length === 0) || isNullish(str)) {
    return placeholder;
  }
  return str;
};

/**
 * 获得随机字符串
 *
 * @param {number} [l=16] 随机字符串长度
 * @return {*} 随机字符长，长度为l
 */
export const getRandomString = function (l = 16) {
  const R = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const a = R.length;
  let result = '';
  for (let i = 0; i < l; i++) result += R.charAt(Math.floor(Math.random() * a));
  return result;
};

const URL_TEST_REG = new RegExp('(?:(?:https?|ftp|file)://|www.|ftp.)' +
    '(?:([-A-Z0-9+&@#/%=~_|$?!:,.]*)|[-A-Z0-9+&@#/%=~_|$?!:,.])*' +
    '(?:([-A-Z0-9+&@#/%=~_|$?!:,.]*)|[A-Z0-9+&@#/%=~_|$])');
export const isStringValidUrl = function (str: string) {
  return URL_TEST_REG.test(str);
};

export const getStringUrl = (str: string) => {
  if (!str) return str;
  return str.match(/(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/)?.[0] || null;
};

export const getValidHalfCharStringInLengthLimit = (str: string, {
  maxLength = 1,
}): string => {
  if (
    !maxLength ||
    str.length < maxLength
  ) {
    return str;
  }
  let validLength = 0;
  let validIndex = 0;
  let shouldClip = false;
  for (validIndex; validIndex < str.length; validIndex++) {
    if (str.charCodeAt(validIndex) <= 127) validLength += 0.5;
    else validLength += 1;
    if (maxLength < validLength) {
      shouldClip = true;
      break;
    }
  }
  return shouldClip ? str.slice(0, validIndex) : str;
};

export const getStrlen = (str: string) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
};

export const intNumberStringFill = (num: number, targetLength = 5) => {
  const numStr = `${num}`;
  const fillLength = targetLength - numStr.length;
  let preStr = '';
  for (let i = 0; i < fillLength; i++) {
    preStr += '0';
  }
  return `${preStr}${numStr}`;
};
